import { render, staticRenderFns } from "./NewDidWithProperty.vue?vue&type=template&id=6ce387aa&scoped=true&"
import script from "./NewDidWithProperty.vue?vue&type=script&lang=js&"
export * from "./NewDidWithProperty.vue?vue&type=script&lang=js&"
import style0 from "./NewDidWithProperty.vue?vue&type=style&index=0&id=6ce387aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce387aa",
  null
  
)

export default component.exports